module.exports = __webpack_public_path__ + "img/food-bits.14c40fb9.png";